export default "__VITE_ASSET__BRgphqJd__"